import { useEffect, useRef } from "react";
import api from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    const finish = async () => {
      try {
        if (sessionId) {
          await api.post("/auth/session", { session_id: sessionId });
        }
      } catch (e) {
        // ignore, will redirect to login if not authed
      } finally {
        window.location.replace("/dashboard");
      }
    };
    finish();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="h-8 w-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 label-caps">Signing you in…</p>
      </div>
    </div>
  );
}
